// @ts-nocheck
import {
    NET_CASH_REPORT_FIRST_GROUP_DATA_CHANGED,
    NET_CASH_REPORT_SECOND_GROUP_DATA_CHANGED,
    NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CHANGED,
    NET_CASH_REPORT_FIRST_GROUP_DATA_CLEARED,
    NET_CASH_REPORT_SECOND_GROUP_DATA_CLEARED,
    NET_CASH_REPORT_LOG_DATA_CHANGED,
    NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CLEARED,
} from '../types';

const initialFirstGroupState = {
    reports: [],
    summary: {},
};

const initialState = {
    firstGroup: initialFirstGroupState,
    expandedFirstGroupRows: [],
    secondGroup: {},
    netCashLogs: [],
};

const netCashReport = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case NET_CASH_REPORT_FIRST_GROUP_DATA_CHANGED: {
            return {
                ...state,
                firstGroup: {
                    ...state.firstGroup,
                    ...payload,
                },
            };
        }
        case NET_CASH_REPORT_FIRST_GROUP_DATA_CLEARED: {
            return {
                ...state,
                firstGroup: initialFirstGroupState,
            };
        }
        case NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CLEARED: {
            return {
                ...state,
                expandedFirstGroupRows: initialState.expandedFirstGroupRows,
            };
        }
        case NET_CASH_REPORT_SECOND_GROUP_DATA_CHANGED: {
            return {
                ...state,
                secondGroup: {
                    ...state.secondGroup,
                    [payload.groupId]: { ...state.secondGroup[payload.groupId], ...payload.data },
                },
            };
        }
        case NET_CASH_REPORT_SECOND_GROUP_DATA_CLEARED: {
            return {
                ...state,
                secondGroup: initialState.secondGroup,
            };
        }
        case NET_CASH_REPORT_FIRST_GROUP_EXPANDED_ROWS_CHANGED: {
            const found = state.expandedFirstGroupRows.includes(payload);
            const newExpandedRows = found
                ? state.expandedFirstGroupRows.filter(row => row !== payload)
                : state.expandedFirstGroupRows.concat(payload);

            return {
                ...state,
                expandedFirstGroupRows: newExpandedRows,
            };
        }
        case NET_CASH_REPORT_LOG_DATA_CHANGED: {
            return {
                ...state,
                netCashLogs: payload,
            };
        }
        default:
            return state;
    }
};

export default netCashReport;
